<template>
  <div class="userInfo_box">
    <p>{{$t('logoff.text2')}}</p>
    <div class="table_box"
         v-show="roleInfoFlag">
      <ul>
        <li class="one-txt-cut">{{$t('logoff.tourText2')}}: {{roleInfo.game}}</li>
        <li class="one-txt-cut">{{$t('logoff.tourText3')}}: {{roleInfo.role_name}}</li>
        <li class="one-txt-cut">{{$t('logoff.tourText4')}}: {{roleInfo.user_id}}</li>
        <li class="one-txt-cut">{{$t('logoff.tourText5')}}: {{roleInfo.level}}</li>
      </ul>
    </div>
    <div v-if="timeFlag">
      <p>{{ beginText}}
      </p>
      <p>{{endText}}</p>
    </div>
    <li class="form_item form_submit"
        @click="cancelClick"
        ref='form_submit'>
      {{$t('toast.comfirmBtn1')}}
    </li>
  </div>
</template>

<script>
import { appPostMessage } from '@/utils/communication'
import { getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
        timeFlag:true,
      userInfoList: {},
      terminalName: '158****6932',
      beginTime: '',
      endTime: '',
      roleInfo: '',
      endText: '',
      beginText: '',
      roleInfoFlag: '',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))
      this.accountInfo = JSON.parse(getSessionStorage('accountStorage'))
      if (getSessionStorage('guestRole') != 'undefined') {
        this.roleInfo = JSON.parse(getSessionStorage('guestRole'))
        this.roleInfoFlag = true
      } else {
        this.roleInfo = { game: '', role_name: '', user_id: '', level: '' }
        this.roleInfoFlag = false
      }
      if (this.accountInfo.web_config.del_user_ttl) {
        const del_user_ttl = parseInt(this.accountInfo.web_config.del_user_ttl)
        this.endTime = this.getDate(del_user_ttl)
      } else {
        this.timeFlag=false
        const time = 14 * 86400
        this.endTime = this.getDate(time)
      }
      this.beginTime = this.getDate(0)

      this.beginText = this.getText(this.$t('logoff.text3'), this.beginTime)
      this.endText = this.getText(this.$t('logoff.text4'), this.endTime)
    },
    // getNextStep() {
    //   if (!this.timeFlag) {
    //     this.$router.push({ path: '/logoffTips1' })
    //   }
    // },
    getText(data, time) {
      return data.replace('{time}', time)
    },
    getDate(n) {
      //   console.log(n)
      //   var ss = 24 * 60 * 60 * 1000 //一天的毫秒数86400
      var ss = 1000
      var timestamp = new Date().getTime() //获取当前时间戳
      var date1 = new Date(ss * n + timestamp) //加上n天的国际标准日期
      var year = date1.getFullYear() //  返回的是年份
      let month = date1.getMonth() + 1
      let dat = date1.getDate()
      var hour = date1.getHours() // 时
      var minutes = date1.getMinutes() // 分
      let m = month > 9 ? month : '0' + month
      let d = dat > 9 ? dat : '0' + dat
      let h = hour > 9 ? hour : '0' + hour
      let min = minutes > 9 ? minutes : '0' + minutes
      var timeStar = `${year}-${m}-${d} ${h}: ${min}`
      if (n > 0) {
        timeStar = `${year}-${m}-${d} 23:59`
      }
      return timeStar //拼接成我们需要的格式返回
    },
    cancelClick() {
      this.$t('logoff.logoffScuessTips')
      setTimeout(() => {
        const appmsg = { code: 8, data: '' }
        appPostMessage(appmsg)
      }, 1000)
    },
  },
}
</script>

<style scope lang="less">
.userInfo_box {
  width: 100%;
  padding: 30/75rem;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  p {
    font-size: 28/75rem;
    font-weight: 400;
    color: #575757;
    margin-bottom: 20/75rem;
  }
  .table_box {
    width: 610/75rem;
    height: 250/75rem;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #c7c7c7;
    padding: 30/75rem 35/75rem;
    box-sizing: border-box;
    margin: 0 auto;
    font-size: 28/75rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    margin-bottom: 20/75rem;
    li {
        width: 530/75rem;
      margin-bottom: 10/75rem;
    }
  }
  .tips {
    margin-top: 45/75rem;
  }

  .form_submit {
    width: 685/75rem;
    height: 76/75rem;
    background: #ff7391;
    // background: rgba(207, 207, 207, 0.39);
    opacity: 1;
    border-radius: 6/75rem;
    font-family: 'Microsoft YaHei';
    font-size: 30/75rem;
    color: #fff;
    line-height: 76/75rem;
    letter-spacing: 10/75rem;
    position: absolute;
    bottom: 60/75rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>